<template>
    <v-layout>
        <v-text-field
                v-if="field.type === 'text'"
                :rules="rules"
                :value="field.default_value"
                @keydown.enter.prevent="()=>{}"
                :clearable="!readonly"
                :readonly="readonly"
                v-model="model"
                :label="field.label" />

        <v-select
                v-if="field.type === 'select'"
                :rules="rules"
                menu-props="auto"
                auto-select-first
                :value="field.default_value"
                :items="field.options"
                :readonly="readonly"
                @keydown.enter.prevent="()=>{}"
                v-model="model"
                :label="field.label">
            <template v-slot:no-data="">
                <div class="py-1 text-center">Valor inválido</div>
            </template>
        </v-select>

    </v-layout>
</template>
<script>
    export default{
        props: {
            field: {
                type: Object,
                required: true
            },
            readonly:{
                type: Boolean
            }
        },
      mounted() {
          const vm = this
          vm.setDefault()
      },
      data(){
            return {
                model: '',
                rules: [
                    v => !!v || 'Campo obligatorio'
                ],
            }
        },
      methods:{
          setDefault(){
            const vm = this
            vm.model = vm.field && vm.field.value || vm.field.default_value
          }
      },
        watch:{
            model(val){
              console.log('field changed', val)
                this.$emit('change', val)
            }
        },


    }
</script>
